import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Stories from './pages/Stories';
import SingleStory from './pages/SingleStory';
import styleApp from './app.module.css';
import StoriesVideos from './pages/StoriesVideo';
import StoriesPodcast from './pages/StoriesPodcast';
import StoriesReview from './pages/StoriesReview';

const App = () => {
	return (
		<BrowserRouter>
			<div className={styleApp.navbar}>
				<Navbar />
			</div>
			<Routes>
				<Route path="/story/:slug" element={<SingleStory />} />
				<Route path="/" element={<Stories />} />
				<Route path="/videos" element={<StoriesVideos />} />
				<Route path="/sounds" element={<StoriesPodcast />} />
				<Route path="/impressions" element={<StoriesReview />} />
				{/* Legacy URL aliases */}
				<Route path="/tv" element={<Navigate to="/videos" replace />} />
				<Route path="/radio" element={<Navigate to="/sounds" replace />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</BrowserRouter>
	);
};

export default App;
